module.exports = __webpack_public_path__ + "assets/img/axios_delete.51dc5ec5.jpg";